import _ from 'underscore';
import constants from '../constants/index';
import normalize from '../lib/normalize';

const defaultState = normalize({selected: []}, [
  { 
    id: 'teacher',
    name: 'Staff'
  },
  { 
    id: 'cohort',
    name: 'Student Cohorts'
  },
  {
    id: 'facilities',
    name: 'Facilities'
  },
  {
    id: 'time',
    name: 'Time'
  }
]);

export default function meetingLabels(state = defaultState, action) {
  let newState = state;

  switch(action.type) {
    case constants.SELECT_MEETING_LABEL:
      newState = Object.assign({}, newState);
      if(action.payload.selected) {
        newState.selected = newState.selected.concat(action.payload.id);
      }
      else {
        newState.selected = _.without(newState.selected, action.payload.id);
      }
      break;
    default:
  }
  return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/meeting_labels_reducer.js
 **/